module.exports = __webpack_public_path__ + "img/tool-head.b8499db1.jpg";